import { GenericAlert } from "@studio3t/generic-components";
import styled from "styled-components";
import { useEntitlementsPolling } from "@/hooks";
import type { Entitlements } from "@/types/api";

const BannerWrap = styled.div`
  padding: 8px 16px 0;
`;

export function LicenseBanner() {
  const { data } = useEntitlementsPolling();

  if (!data || data.valid) {
    return null;
  }

  return (
    <BannerWrap>
      <GenericAlert
        state="Error"
        icon
        dismissible={false}
        message={buildMessage(data)}
        testId="license-banner"
      />
    </BannerWrap>
  );
}

function buildMessage(e: Entitlements): string {
  const reason = e.denied_reason ?? "INVALID";
  const expiredFor = e.license_expires ? daysSince(e.license_expires) : null;
  const expiryClause =
    expiredFor !== null && expiredFor >= 0
      ? `expired ${expiredFor} day${expiredFor === 1 ? "" : "s"} ago`
      : "is no longer valid";
  return `Your 3TL Bridge license ${expiryClause} (${reason}). Contact support to renew — pipelines may stop running soon.`;
}

function daysSince(isoDate: string): number | null {
  const then = Date.parse(isoDate);
  if (Number.isNaN(then)) return null;
  const ms = Date.now() - then;
  return Math.floor(ms / (24 * 60 * 60 * 1000));
}
